// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__jPErn","gap":"gap__rwboq"};